<main class="autorizacao-pagina">
  <div class="autorizacao-marca">Meucardápio <span>Assinaturas</span></div>
  <article class="autorizacao-cartao" aria-labelledby="autorizacao-titulo">
    <header class="autorizacao-cabecalho">
      <div class="autorizacao-icone" aria-hidden="true"><i class="fas fa-qrcode"></i></div>
      <div>
        <p class="autorizacao-etiqueta">PIX AUTOMÁTICO</p>
        <h1 id="autorizacao-titulo">Autorize os débitos da sua assinatura</h1>
        <p class="autorizacao-subtitulo">Confira as condições e conclua a autorização no aplicativo do seu banco.</p>
      </div>
    </header>

    <div class="autorizacao-erro" role="alert" *ngIf="erro"><i class="fas fa-exclamation-circle" aria-hidden="true"></i>{{erro}}</div>
    <p class="autorizacao-carregando" role="status" *ngIf="carregando && !autorizacao">
      <i class="fas fa-spinner fa-spin" aria-hidden="true"></i> Consultando autorização…
    </p>

    <ng-container *ngIf="autorizacao">
      <div class="autorizacao-status" role="status" aria-live="polite"
           [class.confirmada]="autorizacao.status === 'CONFIRMED'"
           [class.encerrada]="['ERROR', 'REJECTED', 'EXPIRED', 'CANCELLED'].includes(autorizacao.status)">
        <i class="fas" [ngClass]="autorizacao.status === 'CONFIRMED' ? 'fa-check-circle' : 'fa-info-circle'" aria-hidden="true"></i>
        <span>{{mensagens[autorizacao.status] || 'Consulte o status da autorização no aplicativo do seu banco.'}}</span>
      </div>

      <div class="autorizacao-conteudo" [class.sem-qr]="!autorizacao.pix">
        <section class="autorizacao-resumo" aria-labelledby="condicoes-titulo">
          <div class="autorizacao-principal">
            <p class="autorizacao-etiqueta">SUA ASSINATURA</p>
            <h2 id="condicoes-titulo">{{autorizacao.empresa}}</h2>
            <ng-container *ngIf="autorizacao.resumo as resumo">
              <p class="autorizacao-descricao" *ngIf="resumo.descricao">{{resumo.descricao}}</p>
              <div class="autorizacao-valor" *ngIf="resumo.valorFixo != null">
                <span>Valor fixo por ciclo</span>
                <strong>{{resumo.valorFixo | currency:'BRL'}}</strong>
              </div>
              <div class="autorizacao-variavel" *ngIf="resumo.valorFixo == null">
                <strong>Cobrança de valor variável</strong>
                <p>O valor de cada fatura será informado antes do débito, respeitando o limite autorizado no banco.</p>
              </div>
            </ng-container>

            <dl class="autorizacao-datas">
              <div *ngIf="autorizacao.frequencyType">
                <dt>Periodicidade</dt>
                <dd>{{frequencias[autorizacao.frequencyType] || autorizacao.frequencyType}}</dd>
              </div>
              <div *ngIf="autorizacao.inicio">
                <dt>Início dos débitos</dt>
                <dd>{{autorizacao.inicio | date:'dd/MM/yyyy'}}</dd>
              </div>
            </dl>
            <p class="autorizacao-limite" *ngIf="autorizacao.valorMinimo">Limite mínimo para autorização: <strong>{{autorizacao.valorMinimo | currency:'BRL'}}</strong></p>
          </div>

          <dl class="autorizacao-detalhes" *ngIf="autorizacao.resumo as resumo">
            <div *ngIf="resumo.recebedor">
              <dt>Recebedor</dt>
              <dd>{{resumo.recebedor}}<span *ngIf="resumo.documentoRecebedor">CPF/CNPJ: {{resumo.documentoRecebedor}}</span></dd>
            </div>
            <div *ngIf="resumo.contrato"><dt>Contrato</dt><dd>{{resumo.contrato}}</dd></div>
            <div><dt>Duração</dt><dd>{{resumo.fim ? ('Até ' + (resumo.fim | date:'dd/MM/yyyy')) : 'Até o cancelamento da autorização'}}</dd></div>
          </dl>
          <p class="autorizacao-retentativas" *ngIf="autorizacao.resumo?.permiteRetentativas">
            Se o débito não for concluído, poderão ocorrer novas tentativas conforme as regras do Pix Automático.
          </p>
        </section>

        <section class="autorizacao-banco" *ngIf="autorizacao.pix" aria-labelledby="banco-titulo">
          <h2 id="banco-titulo">Continue no seu banco</h2>
          <p>Leia o QR Code abaixo ou use Pix Copia e Cola.</p>
          <div class="autorizacao-sem-pagamento"><i class="fas fa-shield-alt" aria-hidden="true"></i><span>É só uma autorização.<strong>Nenhum pagamento é feito agora.</strong></span></div>
          <div class="autorizacao-qr"><app-pagamento-pix-fatura [pix]="autorizacao.pix"></app-pagamento-pix-fatura></div>
          <ol class="autorizacao-passos">
            <li><span>1</span>Abra a área Pix no aplicativo do seu banco.</li>
            <li><span>2</span>Leia o QR Code ou cole o código copiado.</li>
            <li><span>3</span>Confira as condições e autorize os débitos.</li>
          </ol>
        </section>
      </div>
    </ng-container>

    <footer class="autorizacao-rodape">
      <p><i class="fas fa-sync-alt" aria-hidden="true"></i> O status é atualizado automaticamente.<span>A confirmação no banco pode levar alguns instantes.</span></p>
      <button class="autorizacao-atualizar" type="button" [disabled]="carregando" (click)="atualize()">
        <i class="fas" [ngClass]="carregando ? 'fa-spinner fa-spin' : 'fa-sync-alt'" aria-hidden="true"></i>
        {{carregando ? 'Atualizando…' : 'Atualizar status'}}
      </button>
    </footer>
  </article>
</main>
